
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { supabase } from '../../config/supabase';
import './Admin.css';

const AdminLogin = () => {
    const [credentials, setCredentials] = useState({ email: '', password: '' });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const { signIn, user, isAdmin, loading: authLoading } = useAuth();

    // If already logged in as admin, redirect to dashboard
    useEffect(() => {
        if (!authLoading && user && isAdmin()) {
            const from = location.state?.from || '/admin/dashboard';
            navigate(from, { replace: true });
        }
    }, [user, authLoading, isAdmin, navigate, location.state]);

    const handleChange = (e) => {
        setCredentials({ ...credentials, [e.target.name]: e.target.value });
        setError('');
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const data = await signIn(credentials.email, credentials.password);
            
            // Get role from users table
            const { data: userData, error: userError } = await supabase
                .from('users')
                .select('role, full_name')
                .eq('id', data.user.id)
                .single();

            if (userError) {
                console.error('Error fetching user role:', userError);
            }

            let userRole = 'user';
            let fullName = data.user.email;

            if (userData) {
                userRole = userData.role;
                fullName = userData.full_name || data.user.email;
            }

            // Check if user is admin
            if (userRole !== 'admin') {
                await supabase.auth.signOut();
                setError('Access denied. This login is for administrators only.');
                setLoading(false);
                return;
            }

            // Wait a moment for auth state to propagate
            await new Promise(resolve => setTimeout(resolve, 500));
            
            navigate('/admin/dashboard', { replace: true });

        } catch (err) {
            console.error('Admin login error:', err);
            setError(err.message || 'Login failed. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-login-page">
            <div className="admin-login-card">
                <h2>Admin Panel Access</h2>
                <p>Please log in to manage the website.</p>

                {error && <div className="error-message">{error}</div>}

                <form onSubmit={handleLogin}>
                    <div className="form-group">
                        <label>Email</label>
                        <input
                            type="email"
                            name="email"
                            value={credentials.email}
                            onChange={handleChange}
                            placeholder="admin@pharma.com"
                            required
                            autoComplete="email"
                        />
                    </div>
                    <div className="form-group">
                        <label>Password</label>
                        <input
                            type="password"
                            name="password"
                            value={credentials.password}
                            onChange={handleChange}
                            placeholder="Enter password"
                            required
                            autoComplete="current-password"
                        />
                    </div>
                    <button type="submit" className="btn-primary" style={{ width: '100%' }} disabled={loading}>
                        {loading ? 'Logging in...' : 'Login'}
                    </button>
                </form>
                
                <p style={{ marginTop: '20px', fontSize: '0.9rem', color: '#666' }}>
                    <strong>Note:</strong> This login is for administrators only.<br/>
                    Regular users should login from the main site.
                </p>
            </div>
        </div>
    );
};

export default AdminLogin;
